import adminServices from "@/services/admin";
import addMeetFounder from "./addMeetFounder";
import _ from "lodash";
import notify from "@/services/notify";
import Table, { debounce, Dropdown, DropdownItem } from "@/components/Table";
import TextField from "@/components/TextField";
import SelectField from "@/components/SelectField";
import Dialog from "@/components/Dialog";


export default {
  components: {
    Table,
    TextField,
    SelectField,
    addMeetFounder,
    Dialog,
    Dropdown,
    DropdownItem,
  },
  data() {
    return {
      rows: [],
      totalItems: 0,
      loading: false,
      filteredStatus: null,
      filteredCompanyName: null,
      filteredExited: null,
      columns: [
        {
          id: "company_name",
          name: "Company name",
          _wordBreak: "break-word",
          _minWidth: "150px",
        },
        {
          id: "founder_info",
          name: "Founder name",
          _wordBreak: "break-word",
          _minWidth: "150px",
        },
        {
          id: "founder_title",
          name: "Founder title",
          _wordBreak: "break-word",
          _minWidth: "150px",
        },
        {
          id: "title",
          name: "Description title",
          _wordBreak: "break-word",
          _minWidth: "150px",
        },
        {
          id: "is_exited",
          name: "Exited",
        },
        {
          id: "created_at",
          name: "Created Date",
          columnClass: "multiple-line",
        },
        {
          id: "is_active",
          name: "Active",
        },
        {
          id: "actions",
          name: "Actions",
          titleClass: "text-right",
          columnClass: "text-right",
        },
      ],
      statusList: [
        {
          name: "All",
          code: null,
        },
        {
          name: "Active",
          code: true,
        },
        {
          name: "Inactive",
          code: false,
        },
      ],
      exitedList: [
        {
          name: "All",
          code: null,
        },
        {
          name: "Yes",
          code: true,
        },
        {
          name: "No",
          code: false,
        },
      ],
      confirmText: {
        header: "",
        body: "",
      },

      itemModalKey: 0,
      memberList: [
        {
          name: "All",
          code: null,
        },
      ],
    };
  },

  watch: {
    filteredStatus() {
      this.setPageDefault()
      debounce(this.getAll);
    },
    filteredCompanyName() {
      this.setPageDefault()
      debounce(this.getAll);
    },
    filteredExited() {
      this.setPageDefault()
      debounce(this.getAll);
    },
  },
  filters: {
    getName(val, list) {
      let type = _.find(list, (x) => x.code === val);
      return type && type.name ? type.name : "";
    },
  },
  mounted() {
    debounce(this.getAll);
  },
  methods: {
    setPageDefault() {
      this.paging = {
        page: 1,
        size: 10,
        total: 0,
      };
    },
    async getAll() {
      this.loading = true;
      const res = await adminServices.getMeetFounders({
        filteredStatus: this.filteredStatus,
        filteredCompanyName: this.filteredCompanyName,
        filteredExited: this.filteredExited,
      });
      if (res && res.data && res.data.ok) {
        this.rows = res.data.d;
        this.rows.forEach((row) => {
          row["founder_title"] = row["founder_info"];
        });
      }
      this.loading = false;
    },

    async addItem() {
      this.itemModalKey++;
      this.$nextTick(() => {
        this.$refs.itemModal.create();
      });
    },
    async editItem(props) {
      this.itemModalKey++;
      const item = { ...props };
      this.$nextTick(() => {
        this.$refs.itemModal.show(item);
      });
    },
    updateStatus(props) {
      this.loading = true;
      adminServices.updateStatusMeetFounder(
        props.meet_founder_id,
        props.is_active ? false : true
      ).then(res => {
        if (res && res.data && res.data.ok) {
          notify.success("Update status successfully");
          this.getAll();
        } else {
          notify.error(res.data.d.errorMessage);
        }
      }).finally(() => {
        this.loading = false;
      })
    },
    async deleteItem(props) {
      let message = {
        title: "Delete Company",
        body: `Are you sure to delete this company? If you delete it, this company cannot be reverted`,
      };
      let options = {
        html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
        okText: "Confirm",
        cancelText: "Cancel",
        animation: "fade", // Available: "zoom", "bounce", "fade"
        type: "basic", // coming soon: 'soft', 'hard'
        customClassHeader: "custom-header-model",
        customClass: "confirmDeleteMember", // Custom class to be injected into the parent node for the current dialog instance
      };
      this.$refs.dialog
        .confirm({ ...message, ...options })
        .then(async (d) => {
          if (!d) return;
          this.onConfirmToRemove(props);
        })
        .catch(function () {
          // This will be triggered when user clicks on cancel
        });
    },
    async onConfirmToRemove(props) {
      this.loading = true;
      if (props) {
        const res = await adminServices.deleteMeetFounder(
          props.meet_founder_id
        );
        if (res && res.data && res.data.ok) {
          notify.success("Delete successfully");
          this.getAll();
        } else {
          notify.error(res.data.d.errorMessage);
        }
      }
      this.loading = false;
    },

    async orderChanged(items) {
      let tmpData = _.cloneDeep(items);
      tmpData.map((x, idx) => {
        x.order_number = idx + 1;
        return x;
      });
      this.loading = true;
      const res = await adminServices.orderChangedMeetFounder(tmpData);
      if (res.data.ok) {
        notify.success("Ordered successfully!");
        this.getAll();
      }
      this.loading = false;
    },
    hideConfirmModal() {}
  },
};
